import router from './router'
import store from './store'
// import { menuData } from '@/utils/menuData'
import { getFirstValidPath } from '@/utils/index'
// import { generaMenu } from "@/api/index";

router.beforeEach(async(to, from, next) => { 
  const token = window.localStorage.getItem('token')
  const filterMenuData = store.getters.menuList // 拿到store中的菜单
  if (token) {
    if (!filterMenuData.length) { // 如果没有菜单
        next('/login')   
    } else if (to.path === '/login' && filterMenuData.length) {
      const pathValue = getFirstValidPath(filterMenuData) // 跳转到第一个菜单
      next(pathValue)
    } else if (to.path === '/' && filterMenuData.length) {
      const pathValue = getFirstValidPath(filterMenuData) // 跳转到第一个菜单
      next(pathValue)
    } else {
      const userInfo = store.getters.userInfo
      if (!userInfo) {
        await store.dispatch('user/getUserInfo')
      }
      // 请求侧边栏接口
      console.log('store.getters.userInfo.authority: ', store.getters.userInfo.authority)
      const tabs = store.getters.tabs
      const index = tabs.findIndex((tab) => tab.path === to.path)
      if (index < 0) {
        const newTabs = tabs.concat({
          path: to.path,
          name: to.name,
          meta: to.meta
        })
        store.dispatch('menu/setTabs', newTabs)
        store.dispatch('menu/setCurrentTab', newTabs[newTabs.length - 1])
      } else {
        store.dispatch('menu/setCurrentTab', tabs[index])
      }
      next()
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      //展厅看板
      if(to.path == '/LargeDataScreen/EnergyUseDataShow' || to.path == '/LargeDataScreen/IncomeEnergyLeiLiShow'){      
        next()
      }else{
        store.dispatch('menu/setCurrentTab', null)
        store.dispatch('menu/setTabs', [])
        store.dispatch('user/setUserId', '')
        store.dispatch('user/setUserInfo', null)
        next('/login')
      }
      
    }
  }
})
